import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ImagePlus, X } from 'lucide-react';

export const PhotoUploadSection = ({ existingPhotos, photos, photoInputRef, onPhotoSelect, onRemoveNew, onRemoveExisting, t }) => (
  <Card className="mb-6" data-testid="photo-upload-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <ImagePlus className="h-5 w-5 text-orange-500" />
        {t('create.photos') || 'Fotos'}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="flex flex-wrap gap-3">
        {existingPhotos.map((photo) => (
          <div key={photo.attachment_id} className="relative w-28 h-28 rounded-lg overflow-hidden border group" data-testid={`existing-photo-${photo.attachment_id}`}>
            <img src={photo.file_url} alt="" className="w-full h-full object-cover" />
            <button
              onClick={() => onRemoveExisting(photo.attachment_id, 'photo')}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`remove-existing-photo-${photo.attachment_id}`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        {photos.map((file, i) => (
          <div key={i} className="relative w-28 h-28 rounded-lg overflow-hidden border group" data-testid={`new-photo-${i}`}>
            <img src={URL.createObjectURL(file)} alt="" className="w-full h-full object-cover" />
            <button
              onClick={() => onRemoveNew(i)}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`remove-new-photo-${i}`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <button
          onClick={() => photoInputRef.current?.click()}
          className="w-28 h-28 rounded-lg border-2 border-dashed border-slate-300 dark:border-slate-600 flex flex-col items-center justify-center text-muted-foreground hover:border-orange-400 hover:text-orange-500 transition-colors"
          data-testid="add-photo-button"
        >
          <ImagePlus className="h-6 w-6 mb-1" />
          <span className="text-xs">{t('create.addPhoto') || 'Foto'}</span>
        </button>
        <input ref={photoInputRef} type="file" accept="image/*" multiple className="hidden" onChange={onPhotoSelect} />
      </div>
    </CardContent>
  </Card>
);
